<div class="flex-col">
  @for (tab of app.visibleMenuTabs; track tab; let index = $index) {
    <div class="sidebar-item" [ngClass]="{'active-item':appComponent.activeSidebarTabIndex === index}">
      <a href="#" (click)="appComponent.onTabClick($event, index)">
        @if (!tab.iconIsFile) {
          <i [class]="tab.icon"></i>
        }
        @if (tab.iconIsFile) {
          <img class="icon-from-file" [src]="tab.icon">
        }
      </a>
    </div>
  }
</div>
